// Contact Form 7: prevent double-submit. On click, disable submit button visually.
// Re-enable on wpcf7invalid (validation failure) so user can fix and resubmit.
export function initCf7SubmitGuard() {
  const btns = document.querySelectorAll("input[type='submit'].wpcf7-submit");
  if (!btns.length) return;
  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.5';
    });
  });
  document.addEventListener('wpcf7invalid', () => {
    btns.forEach((btn) => {
      btn.style.pointerEvents = '';
      btn.style.opacity = '';
    });
  });
}
